import LargeContentToggle from 'components/Common/LargeContentToggle'
import type { ReactNode } from 'react'
import { useIntl } from 'react-intl'

// Matches the standard package-card inclusion preview height, allowing up to
// five typical inclusion rows before customers need to expand the list.
const FIRST_PACKAGE_INCLUSIONS_COLLAPSED_MAX_HEIGHT = 208
const SUBSEQUENT_PACKAGE_INCLUSIONS_COLLAPSED_MAX_HEIGHT = 164

interface Props {
  children: ReactNode
  packagePosition?: number
  open?: boolean
  onToggle?: () => void
}

function FlashHotelInclusionsToggle({ children, packagePosition, open, onToggle }: Props) {
  const intl = useIntl()
  const maxHeight = packagePosition === undefined || packagePosition === 1
    ? FIRST_PACKAGE_INCLUSIONS_COLLAPSED_MAX_HEIGHT
    : SUBSEQUENT_PACKAGE_INCLUSIONS_COLLAPSED_MAX_HEIGHT

  const showMoreText = intl.formatMessage({
    id: 'Z2TgaCuIlotsrKRmKce-',
    defaultMessage: 'View more inclusions',
  })
  const showLessText = intl.formatMessage({
    id: 'FNKxHD3fFrTa43MyF1At',
    defaultMessage: 'View less inclusions',
  })

  return <LargeContentToggle
    maxHeight={maxHeight}
    showMoreText={showMoreText}
    showLessText={showLessText}
    open={open}
    onToggle={onToggle}
  >
    {children}
  </LargeContentToggle>
}

export default FlashHotelInclusionsToggle
